<template>
    <v-card class="mx-auto EK-card pt-5 rounded-xl rounded-tl-0 IMThemeGray action-form">
        <v-card-title class="py-3 justify-content-center IMThemeOrange text-white rounded-0">
            تفاصيل
        </v-card-title>
        <v-card-text class="text-right pt-4">
            <v-row>
                <v-col cols="12" sm="6" lg="12" class="py-1">
                    <label for="">الاسم الأول</label>
                    <v-text-field class="rounded-tl-0"
                                  solo
                                  rounded
                                  readonly
                                  dense
                                  v-model="userInfoForm.firstName"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" lg="12" class="py-1">
                    <label for="">الكنية</label>
                    <v-text-field class="rounded-tl-0"
                                  solo
                                  rounded
                                  dense
                                  readonly
                                  v-model="userInfoForm.lastName"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" lg="12" class="py-1">
                    <label for="">رقم الهاتف</label>
                    <v-text-field class="rounded-tl-0"
                                  solo
                                  rounded
                                  readonly
                                  dense
                                  v-model="userInfoForm.phoneNumber"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" lg="12" class="py-1">
                    <label for="">تاريخ الميلاد</label>
                    <v-text-field class="rounded-tl-0"
                                  solo
                                  rounded
                                  readonly
                                  dense
                                  v-model="userInfoForm.birthDate"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" lg="12" class="py-1">
                    <label for="">المحافظة</label>
                    <v-text-field class="rounded-tl-0"
                                  solo
                                  readonly
                                  rounded
                                  dense
                                  v-model="userInfoForm.cityName"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" lg="12" class="py-1">
                    <label for="">المنطقة</label>
                    <v-text-field class="rounded-tl-0"
                                  solo
                                  readonly
                                  rounded
                                  dense
                                  v-model="userInfoForm.areaName"></v-text-field>
                </v-col>

                <v-col cols="12" class="py-1">
                    <div class="align-items-baseline float-right">
                        <label class="ml-2" for="otp">رمز المشترك</label>
                        <v-text-field v-model="userInfoForm.code"
                                      id="otp"
                                      dense
                                      color="dark"
                                      solo
                                      rounded
                                      label="OTP"
                                      class="col-8 rounded-tr-0"
                                      dir="ltr"
                                      type="number"
                                      readonly>
                            <template v-slot:append>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" @click="generateOtp">
                                            mdi-flash
                                        </v-icon>
                                    </template>
                                    توليد رمز جديد
                                </v-tooltip>
                            </template>
                        </v-text-field>
                    </div>
                </v-col>









            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="ConfirmDelete({item: userInfoForm, userIndex})" depressed rounded class="rounded-tr-0 px-10 mx-auto">
                حذف
            </v-btn>
            <v-btn @click="isShowSMS()"
                   dark
                   color="IMThemeOrange"
                   rounded
                   class="rounded-tl-0 px-6 mx-auto">
                إرسال رسالة SMS
            </v-btn>
        </v-card-actions>
        <v-dialog v-model="showSMS" width="1000px">
            <smsModal :Type="2" :Id="userInfoForm.id" @close="isShowSMS()" />
        </v-dialog>
    </v-card>
</template>
<script>
    import smsModal from "@/components/smsModal.vue";

import { mapGetters, mapActions } from "vuex";
export default {
    props: {
        userIndex: String
        },
        components: {
            smsModal
        },
    created() {
        this.getDetailsUser(this.userIndex);
        this.offset = this.getOffset( document.querySelector('.action-form') ).top; 
        setTimeout(() => {
            window.scrollTo(this.offset, this.offset)
        }, 100)
        },
        data: () => ({
            showSMS: false,
        }),
    computed: {
        ...mapGetters(["userInfoForm"])
    },
        methods: {
            isShowSMS() {
                this.showSMS = !this.showSMS;
            },
        generateOtp(){
            this.generateUserCode(this.userIndex);
        },
        getOffset( el ) {
            var _x = 0;
            var _y = 0;
            while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
                _x += el.offsetLeft - el.scrollLeft;
                _y += el.offsetTop - el.scrollTop;
                el = el.offsetParent;
            }
            return { top: _y, left: _x };
        },
        ...mapActions(["getDetailsUser", "ConfirmDelete" , "generateUserCode"])
    },
    watch: {
        userIndex(){
            this.getDetailsUser(this.userIndex);
            this.offset = this.getOffset( document.querySelector('.action-form') ).top; 
            setTimeout(() => {
                window.scrollTo(this.offset, this.offset)
            }, 100)
        }
    }
}
</script>